import TYPES from '../types';

export default payload => {
  return {
    type: TYPES.SET_USER,
    payload,
  };
};
